<template>
<div class="filter">
    <button class="filter-btn" :class="{ active: isActive }"  @click="setFilter(slug)">{{ label }}</button>
</div>
</template>
<script setup lang='ts'>

/*  VARIABLES  */
const props = defineProps<{
    label:string
    id?:number
    slug:string
    description? :string
}>()

const store = useFiltersStore()
const route = useRoute()
const router = useRouter()


const isActive = computed(() => store.selectedSlug === props.slug)
const setFilter = (slug: string) => {
    store.setFilter(slug,props.description)
    if (route.query.categories != null) {
    router.replace({ query: {} })  
  }
}



onMounted(() => {
  const categorieId = route.query.categories
  if (categorieId != null && Number(categorieId) === props.id) {
    setFilter(props.slug)
  }
})

</script>

<style lang="scss">
    .filter{
        &-btn{
            padding: 10px 20px; 
            border-radius: 50px;
            color: $text;
            font-weight: 600;
            background-color: $white;
            border: 2px solid $text;
            cursor:pointer;
            &.active{
                background-color: $violet;
                border: 2px solid $violet;
                color: $white;
            }
        }

    }
</style>